export const danishCountryParts = [
  { title: "Byen København", value: 1 },
  { title: "Københavns Omegn", value: 2 },
  { title: "Nordsjælland", value: 3 },
  { title: "Bornholm", value: 4 },
  { title: "Østsjælland", value: 5 },
  { title: "Syd- og Vestsjælland", value: 6 },
  { title: "Fyn", value: 7 },
  { title: "Sydjylland", value: 8 },
  { title: "Østjylland", value: 9 },
  { title: "Vestjylland", value: 10 },
  { title: "Nordjylland", value: 11 },
];

type DanishCountryPart = typeof danishCountryParts[number];

export const danishCountryPartsMap = new Map<string, DanishCountryPart>(
  danishCountryParts.map((part) => [part.value.toString(), part])
);
